var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_vm.isMenuHasSubMenu(_vm.menu) && _vm.allowSubMenus ? [_c('a', {
    staticClass: "dropdown-item",
    class: {
      'router-link-exact-active router-link-active': _vm.isSubMenuRouteActive(_vm.menu)
    },
    attrs: {
      "href": _vm.getFirstSubMenu(_vm.menu),
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toFirstSubMenu(_vm.menu);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.menu.title) + " "), _vm._m(0)]), _vm.isMenuHasPerColumn(_vm.menu) ? _c('ul', {
    staticClass: "dropdown-menu sub-menu multi-column",
    class: {
      'with-sub-menus': _vm.isMenuHasSubMenus(_vm.menu),
      'sub-menu-left': _vm.isMenuOpensLeft(_vm.menu)
    },
    style: {
      gridTemplateRows: ("repeat(" + (_vm.menu.perColumn) + ", auto")
    }
  }, [_vm._l(_vm.menu.subMenus, function (eachSubMenu) {
    return [_c('sub-menu-entity', {
      key: eachSubMenu.name,
      attrs: {
        "menu": eachSubMenu,
        "allow-sub-menus": false
      }
    })];
  })], 2) : _c('ul', {
    staticClass: "dropdown-menu sub-menu",
    class: {
      'with-sub-menus': _vm.isMenuHasSubMenus(_vm.menu),
      'sub-menu-left': _vm.isMenuOpensLeft(_vm.menu)
    }
  }, [_vm._l(_vm.menu.subMenus, function (eachSubMenu) {
    return [_c('sub-menu-entity', {
      key: eachSubMenu.name,
      attrs: {
        "menu": eachSubMenu
      }
    })];
  })], 2)] : [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": _vm.menu.path,
      "role": "menuitem"
    }
  }, [_vm._v(" " + _vm._s(_vm.menu.title) + " ")])]], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-arrow-indicator"
  }, [_c('i', {
    staticClass: "wi-arrow-right_16"
  })]);
}]

export { render, staticRenderFns }